import React from "react";
import BackLogo from '../../../../images/rewampimages/Chevron.png'
import DashboardInactive from './imagesmarket/dashboard (2).png'
import DashboardActactive from './imagesmarket/dashboardActive.png'
import LiveReportInActive from './imagesmarket/crystal-reports-file (1).png'
import LiveReportActive from './imagesmarket/crystal-reports-file (2).png'
import AgreegatorInactive from './imagesmarket/user.png'
import AgreegatorActive from './imagesmarket/user (1).png'
import ReportInactive from './imagesmarket/report.png'
import ReportActive from './imagesmarket/report (1).png'
import BiActive from './imagesmarket/business-intelligence.png'
import BiInActive from './imagesmarket/business-intelligence (1).png'
import Dashbaord from '../newdesigns/overalldashboardnew'
import Aggregators from '../maketingComponents/screens/tabsagreegator'
import BuddyloanReport from '../../../containers/Admin/DashboardAndReports/BuddyLoanReport.container'
import BranchReport from '../../../containers/Admin/DashboardAndReports/BranchData.container'
import Bi from '../../../containers/BuisnessIntelligence/ApplicatonPipelineAnalysis'
import { useState } from "react";
import LeadParticulars from "./leadParticular";
import StatewiseData from "./statewise";
import RejectionStats from "./RejectReasonStats";
import AgestatusData from "./agestatus";
import SalaryRange from "./salaryRange";
import LoanStatusData from "./loanstatus";
import ConversionRatio from "./conversionRatio";
import DeviationReport from "./deviationchart";
import GenderStats from "./genderStats";
import EmiSats from "./emistats";
import BuisnessAggregator from "./buisnessagreegator";
import Image1Inactive from './imagesmarket/Group (9).png'
import Image1active from './imagesmarket/Group (10).png'
import Image2Inactive from './imagesmarket/stats (2).png'
import Image2active from './imagesmarket/stats (1).png'
import Image3Inactive from './imagesmarket/stats (3).png'
import Image3active from './imagesmarket/Vector (29).png'
import Image4Inactive from './imagesmarket/stats (4).png'
import Image4active from './imagesmarket/stats (5).png'
import Image5Inactive from './imagesmarket/range-slider.png'
import Image5active from './imagesmarket/range-slider (1).png'
import Image7Inactive from './imagesmarket/Vector (30).png'
import Image7active from './imagesmarket/statistic-down.png'
import Image8Inactive from './imagesmarket/business (2).png'
import Image8active from './imagesmarket/business (3).png'
import Formstatus from './formstatus'
import Projections from "./projections";
import ProjectionActive from '../maketingimages/prediction (1).png'
import ProjectionInActive from '../maketingimages/prediction (2).png'
import Main from "../maketingComponents/screens/Singular/Main";
import { useSelector } from "react-redux";
import { Company_DATA } from "../../../../layouts/MainTenantconfig";
const MainTabsMarketing = ({ admin, newDataBackground, allStatus, pageViewHandler }) => {
    const tenant = useSelector((state) => state.tenant.activeTenant)
    const [page, setPage] = useState('dashboard')
    const [report, setreport] = useState('')
    const [liveReportTab, setLiveReportTab] = useState('')

    const pageHandler = (data) => {
        setPage(data)
        if (data === 'greport') {
            setreport('buddyloan')
        }
        if (data === 'liveReports') {
            setLiveReportTab('leadParticular')
        }
    }
    return (
        <>
            <div className={page !== 'liveReports' ? "marketing-main-css" : 'marketing-main-css'}>
                <div className="details-new fixed-top">
                    <div className="row details-new-tab-div" style={{ display: 'flex', justifyContent: 'end' }} >
                        <div className="col-sm-4 " style={{ marginTop: '15px' }}>
                            <img onClick={(e) => pageViewHandler(e, 'landingPage')} style={{ cursor: 'pointer' }} src={BackLogo} width={'30px'} /> <button style={{ color: '#1D3557', fontWeight: '700' }} onClick={(e) => pageViewHandler(e, 'landingPage')} >Back</button>
                        </div>
                        <div className="col-sm-8 col-xs-12" style={{ display: 'flex' }}>
                            <div className="btn-group-new" style={{ marginLeft: 'auto', marginRight: '20px' }}>
                                <button className={page === 'dashboard' ? 'active' : ''} onClick={(e) => pageHandler('dashboard')}><img src={page === 'dashboard' ? DashboardActactive : DashboardInactive} style={{ width: '27px' }} /><br />Dashboard</button>
                                <button className={page === 'liveReports' ? 'active' : ''} onClick={(e) => pageHandler('liveReports')}><img src={page === 'liveReports' ? LiveReportActive : LiveReportInActive} style={{ width: '19px' }} /><br />Live Reports</button>
                                <button className={page === 'projection' ? 'active' : ''} onClick={(e) => pageHandler('projection')}><img src={page === 'projection' ? ProjectionActive : ProjectionInActive} style={{ width: '27px' }} /><br />Projection</button>

                                <button className={page === 'aggregators' ? 'active' : ''} onClick={(e) => pageHandler('aggregators')}><img src={page === 'aggregators' ? AgreegatorActive : AgreegatorInactive} style={{ width: '27px' }} /><br />Aggregators</button>
                                {
                                    tenant?.COMPANY_NAME == Company_DATA?.MICROMONEY ?
                                        <button className={page === 'greport' ? 'active' : ''} onClick={(e) => pageHandler('greport')}><img src={page === 'greport' ? ReportActive : ReportInactive} style={{ width: '27px' }} /><br />Generate Report</button>
                                        : ''}
                                {
                                    tenant?.COMPANY_NAME == Company_DATA?.ABHICASH || tenant?.COMPANY_NAME == Company_DATA?.CREDFIN ?
                                        <button className={page === 'singular' ? 'active' : ''} onClick={(e) => pageHandler('singular')}><img src={page === 'singular' ? ReportActive : ReportInactive} style={{ width: '27px' }} /><br />Singular</button>
                                        : ''}
                                {/* <button className={page === 'BI' ? 'active' : ''} onClick={(e) => pageHandler('BI')}><img src={page === 'BI' ? BiActive : BiInActive} style={{ width: '27px' }} /><br />BI</button> */}

                            </div>


                        </div>
                    </div>
                </div>
                {page === 'liveReports' ?
                    <div className="row fixed-top" style={{ marginTop: '76px', fontSize: '14px' }}>
                        <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'leadParticular' ? "active" : ""}`} onClick={() => setLiveReportTab('leadParticular')} style={{ height: '93px' }}>
                            <img src={liveReportTab === 'leadParticular' ? Image1active : Image1Inactive} width={'20px'} />
                            <br />
                            Lead <br />Particulars
                        </div>
                        <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'stateWise' ? "active" : ""}`} onClick={() => setLiveReportTab('stateWise')} style={{ height: '93px' }}>
                            <img src={liveReportTab === 'stateWise' ? Image2active : Image2Inactive} width={'20px'} />
                            <br />
                            State wise<br /> Stats</div>
                        <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'rejectReason' ? "active" : ""}`} onClick={() => setLiveReportTab('rejectReason')} style={{  height: '93px' }}>
                            <img src={liveReportTab === 'rejectReason' ? Image3active : Image3Inactive} width={'20px'} />
                            <br />
                            Reject Reason <br />Stats</div>
                        <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'genderStats' ? "active" : ""}`} onClick={() => setLiveReportTab('genderStats')} style={{  height: '93px' }}>
                            <img src={liveReportTab === 'genderStats' ? Image4active : Image4Inactive} width={'20px'} />
                            <br />
                            Gender<br /> Stats</div>
                        <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'ageStats' ? "active" : ""}`} onClick={() => setLiveReportTab('ageStats')} style={{  height: '93px' }}>
                            <img src={liveReportTab === 'ageStats' ? Image4active : Image4Inactive} width={'20px'} />
                            <br />
                            Age <br />Stats</div>
                        <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'salaryRange' ? "active" : ""}`} onClick={() => setLiveReportTab('salaryRange')} style={{  height: '93px' }}>
                            <img src={liveReportTab === 'salaryRange' ? Image5active : Image5Inactive} width={'20px'} />
                            <br />
                            Salary <br />Range</div>
                        <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'emiStats' ? "active" : ""}`} onClick={() => setLiveReportTab('emiStats')} style={{  height: '93px' }}>
                            <img src={liveReportTab === 'emiStats' ? Image4active : Image4Inactive} width={'20px'} />
                            <br />
                            EMI<br /> Stats</div>
                        <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'loanStatus' ? "active" : ""}`} onClick={() => setLiveReportTab('loanStatus')} style={{  height: '93px' }}>
                            <img src={liveReportTab === 'loanStatus' ? Image4active : Image4Inactive} width={'20px'} />
                            <br />
                            Loan Status <br />Stats</div>
                        <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'formStatus' ? "active" : ""}`} onClick={() => setLiveReportTab('formStatus')} style={{  height: '93px' }}>
                            <img src={liveReportTab === 'formStatus' ? Image4active : Image4Inactive} width={'20px'} />
                            <br />
                            Form Status <br />Stats</div>
                        <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'conversionRatio' ? "active" : ""}`} onClick={() => setLiveReportTab('conversionRatio')} style={{  height: '93px' }}>
                            <img src={liveReportTab === 'conversionRatio' ? Image4active : Image4Inactive} width={'20px'} />
                            <br />
                            Conversion <br />Ratio</div>
                        <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'deviation' ? "active" : ""}`} onClick={() => setLiveReportTab('deviation')} style={{  height: '93px' }}>
                            <img src={liveReportTab === 'deviation' ? Image7active : Image7Inactive} width={'20px'} />
                            <br />
                            Deviation <br />Chart</div>
                        <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'businessAgreegator' ? "active" : ""}`} onClick={() => setLiveReportTab('businessAgreegator')} style={{  height: '93px' }}>
                            <img src={liveReportTab === 'businessAgreegator' ? Image8active : Image8Inactive} width={'20px'} />
                            <br />
                            Business from <br />Aggregators</div>
                    </div>
                    : ""}

                {page === 'dashboard' ?
                    <div className='container-fluid' style={{ marginTop: '70px' }}>
                        <Dashbaord admin={admin} newDataBackground={newDataBackground} allStatus={allStatus} />
                    </div>
                    : ""}
                {page === 'aggregators' ?
                    <div className='container-fluid' style={{ marginTop: '70px' }}>
                        <Aggregators admin={admin} setmargin={true} newDataBackground={newDataBackground} allStatus={allStatus} />
                    </div>
                    : ""}
                {page === 'greport' ?
                    <div className="container row fixed-top" style={{ marginTop: '77px' }}>
                        <div className="col-sm-2 col-xs-12 marketing-sub-tab " style={{ background: report === 'buddyloan' ? '#267fff' : '#DBE9FF', color: report === 'buddyloan' ? '#fff' : '#000', cursor: 'pointer' }} onClick={() => setreport('buddyloan')} >Buddyloan <br />Report</div>
                        <div className="col-sm-2 col-xs-12 marketing-sub-tab " style={{ background: report === 'branch' ? '#267fff' : '#DBE9FF', color: report === 'branch' ? '#fff' : '#000', cursor: 'pointer' }} onClick={() => setreport('branch')} >Branch<br /> Report</div>
                    </div>
                    : ""}
                {report === 'buddyloan' && page === 'greport' ?
                    <div style={{ marginTop: '100px' }}>
                        <BuddyloanReport admin={admin} />
                    </div>
                    : ""}
                {report === 'branch' && page === 'greport' ?
                    <div style={{ marginTop: '100px' }}>
                        <BranchReport admin={admin} />
                    </div>
                    : ""}
                {page === 'BI' ?
                    <div style={{ marginTop: '100px' }}>
                        <Bi />
                    </div>
                    : ""}
                {page === 'singular' ?
                    <div style={{ marginTop: '100px' }}>
                        <Main setmargin={true} />
                    </div>
                    : ""}
                {page === 'liveReports' && liveReportTab === 'leadParticular' ?
                    <div className="container" style={{ marginTop: '200px' }}>
                        <LeadParticulars admin={admin} newDataBackground={newDataBackground} allStatus={allStatus} />
                    </div>
                    : ""}
                {page === 'liveReports' && liveReportTab === 'stateWise' ?
                    <div className="container" style={{ marginTop: '200px' }}>
                        <StatewiseData admin={admin} />
                    </div>
                    : ""}
                {page === 'liveReports' && liveReportTab === 'rejectReason' ?
                    <div className="container" style={{ marginTop: '200px' }}>
                        <RejectionStats admin={admin} />
                    </div>
                    : ""}
                {page === 'liveReports' && liveReportTab === 'ageStats' ?
                    <div className="container" style={{ marginTop: '200px' }}>
                        <AgestatusData admin={admin} />
                    </div>
                    : ""}
                {page === 'liveReports' && liveReportTab === 'salaryRange' ?
                    <div className="container" style={{ marginTop: '200px' }}>
                        <SalaryRange admin={admin} />
                    </div>
                    : ""}
                {page === 'liveReports' && liveReportTab === 'loanStatus' ?
                    <div className="container" style={{ marginTop: '200px' }}>
                        <LoanStatusData admin={admin} />
                    </div>
                    : ""}
                {page === 'liveReports' && liveReportTab === 'conversionRatio' ?
                    <div className="container" style={{ marginTop: '200px' }}>
                        <ConversionRatio admin={admin} />
                    </div>
                    : ""}
                {page === 'liveReports' && liveReportTab === 'deviation' ?
                    <div className="container" style={{ marginTop: '200px' }}>
                        <DeviationReport admin={admin} />
                    </div>
                    : ""}
                {page === 'liveReports' && liveReportTab === 'genderStats' ?
                    <div className="container" style={{ marginTop: '200px' }}>
                        <GenderStats admin={admin} />
                    </div>
                    : ""}
                {page === 'liveReports' && liveReportTab === 'emiStats' ?
                    <div className="container" style={{ marginTop: '200px' }}>
                        <EmiSats admin={admin} />
                    </div>
                    : ""}
                {page === 'liveReports' && liveReportTab === 'businessAgreegator' ?
                    <div className="container" style={{ marginTop: '200px' }}>
                        <BuisnessAggregator admin={admin} />
                    </div>
                    : ""}
                {page === 'liveReports' && liveReportTab === 'formStatus' ?
                    <div className="container" style={{ marginTop: '200px' }}>
                        <Formstatus admin={admin} newDataBackground={newDataBackground} allStatus={allStatus} />
                    </div>
                    : ""}
                {page === 'projection' ?
                    <div style={{ marginTop: '75px', height: '100%', background: window.innerHeight <= 1800 ? '#fff' : '#fff', minHeight: window.innerHeight }}>

                        <Projections />
                    </div>

                    : ""}

            </div>
        </>
    )
}
export default MainTabsMarketing 